import { InitiativeCountry, TemplateRegion } from 'basics/enums/country.enums';

const countriesAndRegionKeys = [...Object.keys(InitiativeCountry), ...Object.keys(TemplateRegion)];
const countriesAndRegionValues = [...Object.values(InitiativeCountry), ...Object.values(TemplateRegion)];
const initiativeCountriesAndRegionOptions = countriesAndRegionValues.map((value, index) => {
  return { id: countriesAndRegionKeys[index], label: value };
});

export default initiativeCountriesAndRegionOptions;
